
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3737_43533)"}},[_c('path',{attrs:{"d":"M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1M12 23C14.2928 19.9878 15.5959 16.0788 15.6667 12C15.5959 7.92124 14.2928 4.01219 12 1M12 23C9.70716 19.9878 8.40414 16.0788 8.33333 12C8.40414 7.92124 9.70716 4.01219 12 1M1 12.5238H23","stroke":"#10001F","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3737_43533"}},[_c('rect',{attrs:{"width":"24","height":"24","fill":"white"}})])])])
          )
        }
      }
    